import cookies from 'js-cookie';

const KEY = 'phemex-auth-token';
const COOKIE_KEY = 'px_token';

const ADMIN_KEY = 'admin-kol-token';

export function readToken() {
  const token = localStorage.getItem(KEY);
  if (token) {
    writeTokenToCookie(token);
  }
  return token;
}

export function readAdminToken() {
  return localStorage.getItem(ADMIN_KEY);
}

export function writeToken(token) {
  localStorage.setItem(KEY, token);
  writeTokenToCookie(token);
}

export function writeAdminToken(token) {
  localStorage.setItem(ADMIN_KEY, token);
}

export function removeToken() {
  localStorage.removeItem(KEY);
  removeTokenFromCookie();
}

export function writeTokenToCookie(token) {
  cookies.set(COOKIE_KEY, token, {expires: 365});
}
export function removeTokenFromCookie() {
  cookies.remove(COOKIE_KEY);
}

export function readAdminBrokerToken() {
  const reg = /admin_broker_token=([^&?]+)/;
  const ret = window.location.search.match(reg);
  return ret && decodeURIComponent(ret[1]);
}
